import { HOW_IT_WORKS_IMAGE } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";
import Button from "../Common/Button";

export default function MixMastersHowItWorks() {
  const steps = [
    {
      number: 1,
      title: "STEP 1",
      description:
        "We begin with understanding your needs, goals, and budget to develop a clear and strategic construction plan.",
    },
    {
      number: 2,
      title: "STEP 2",
      description:
        "Our architects and engineers create detailed designs and cost estimates that align with your project's vision and requirements.",
    },
    {
      number: 3,
      title: "STEP 3",
      description:
        "Skilled professionals manage the entire build process, maintaining high standards, safety, and efficiency from start to finish.",
    },
    {
      number: 4,
      title: "STEP 4",
      description:
        "We hand over your completed project with thorough inspection, quality assurance, and post-completion support for lasting satisfaction.",
    },
  ];

  return (
    <div className="w-full bg-white pt-10 lg:pt-16 px-4 sm:px-6 md:px-8 lg:px-10">
      <div className="">
        {/* MOBILE / TABLET */}
        <div className="flex flex-col lg:hidden gap-8">
          <div>
            <p
              data-aos="fade-up"
              className="font-semibold mb-4"
              style={{
                color: "#c020d0",
                fontSize: "0.7rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
              }}
            >
              [HOW WE WORKS]
            </p>

            <h2
              data-aos="fade-up"
              data-aos-delay="100"
              className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading leading-relaxed   font-semibold mb-4"
            >
              Four Simple Steps Build Your Vision
            </h2>
          </div>

          <div
            data-aos="fade-right"
            className="rounded-2xl overflow-hidden w-full"
            style={{ height: "260px" }}
          >
            <img
              src={getCloudinaryImageUrl(HOW_IT_WORKS_IMAGE, { width: 400 })}
              alt="How We Work"
              className="w-full h-full object-cover"
            />
          </div>

          <div>
            {steps.map((step, i) => (
              <div
                key={step.number}
                data-aos="fade-up"
                data-aos-delay={i * 120}
                className="relative flex gap-5 mb-2"
              >
                <div
                  className="relative flex flex-col items-center"
                  style={{ minWidth: "36px" }}
                >
                  <div
                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 z-10"
                    style={{
                      background: "linear-gradient(135deg, #e040fb, #c020d0)",
                      boxShadow: "0 3px 12px rgba(192,32,208,0.4)",
                    }}
                  >
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        background: "white",
                        opacity: 0.9,
                      }}
                    />
                  </div>

                  {i < steps.length - 1 && (
                    <div
                      style={{
                        width: "2px",
                        flex: 1,
                        minHeight: "40px",
                        background:
                          "linear-gradient(to bottom, #c020d0, rgba(192,32,208,0.2))",
                        marginTop: "4px",
                      }}
                    />
                  )}
                </div>

                <div className="step-row flex-1 pb-4 ">
                  <h3
                    className="font-bold text-gray-900 mb-1 font-heading"
                    style={{ fontSize: "1rem", letterSpacing: "0.03em" }}
                  >
                    {step.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed ">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div
            data-aos="fade-up"
            data-aos-delay="500"
            className="flex justify-start"
          >
            <Button text={"Free Consultation"} />
          </div>
        </div>

        {/* DESKTOP */}
        <div className="hidden lg:flex justify-between gap-10 items-stretch">
          <div
            data-aos="fade-right"
            style={{ width: "340px" }}
            className="flex-shrink-0 flex flex-col justify-between"
          >
            <div className="h-full">
              <p
                className="font-semibold mb-4"
                style={{
                  color: "#c020d0",
                  fontSize: "0.7rem",
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                }}
              >
                [HOW WE WORKS]
              </p>

              <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading leading-relaxed   font-semibold mb-12">
                Four Simple
                <br />
                Steps Build
                <br />
                Your Vision
              </h2>
            </div>

            <div data-aos="fade-up" className="flex justify-start ">
              <Button text={"Free Consultation"} />
            </div>
          </div>

          <div data-aos="fade-up" className="flex-1">
            <div
              className="rounded-2xl overflow-hidden"
              style={{ height: "520px", width: "100%" }}
            >
              <img
                src={getCloudinaryImageUrl(HOW_IT_WORKS_IMAGE, { width: 600 })}
                alt="How We Work"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            {steps.map((step, i) => (
              <div
                key={step.number}
                data-aos="fade-up"
                data-aos-delay={i * 120}
                className="relative flex gap-5 mb-2"
              >
                <div
                  className="relative flex flex-col items-center"
                  style={{ minWidth: "36px" }}
                >
                  <div
                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 z-10"
                    style={{
                      background: "linear-gradient(135deg, #e040fb, #c020d0)",
                      boxShadow: "0 3px 12px rgba(192,32,208,0.4)",
                    }}
                  >
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        background: "white",
                        opacity: 0.9,
                      }}
                    />
                  </div>

                  {i < steps.length - 1 && (
                    <div
                      style={{
                        width: "2px",
                        flex: 1,
                        minHeight: "40px",
                        background:
                          "linear-gradient(to bottom, #c020d0, rgba(192,32,208,0.2))",
                        marginTop: "4px",
                      }}
                    />
                  )}
                </div>

                <div className="step-row flex-1 pb-4">
                  <h3
                    className="font-bold text-gray-900 font-heading mb-1"
                    style={{ fontSize: "1rem", letterSpacing: "0.03em" }}
                  >
                    {step.title}
                  </h3>

                  <p
                    className="text-gray-500 text-sm leading-relaxed"
                    style={{ maxWidth: "340px" }}
                  >
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
